module.exports = __webpack_public_path__ + "static/media/lu.b39e9dda.png";